import { Box, Typography } from "@mui/material";

interface Props {
  title: string;
  rightContent?: React.ReactNode; // optional (future use)
}

const Section: React.FC<Props> = ({ title, rightContent }) => {
  return (
    <Box
      sx={{
        mb: 2,
        mt: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      {/* TITLE */}
      <Typography
        sx={{
          fontSize: 15,
          fontWeight: 600,
          color: "#0f172a",
        }}
      >
        {title}
      </Typography>

      {/* RIGHT SIDE (optional) */}
      {rightContent && <Box>{rightContent}</Box>}
    </Box>
  );
};

export default Section;